import React from 'react';
import classNames from 'classnames';
import { LockOutlinedIcon, PlayCircleIcon } from 'icons';
import { useRouter } from 'next/router';

import { formatDuration, globalConst } from 'modules/global';

import { Visible } from 'components';

interface IProps {
  available?: boolean;
  title?: string;
  progress?: number;
  duration?: number;
  isDrawer?: boolean;
  slug?: string;
}

export const Lesson: React.FC<IProps> = ({
  available = false,
  progress = 0,
  title,
  duration,
  isDrawer = false,
  slug
}) => {
  const { push, query } = useRouter();

  const onListClick = () => {
    if (!available) return;
    push(`${globalConst.pageNames.COURSES}/${query?.course}/${slug}`);
  };

  return (
    <div
      onClick={onListClick}
      className={classNames('flex rounded-lg bg-white p-3', {
        'border-2 border-green-500 !bg-green-50': query?.lesson === slug,
        'cursor-pointer flex-col space-y-3.5 opacity-100': available,
        'cursor-not-allowed items-center justify-between opacity-60': !available,
        'border border-gray-300': isDrawer
      })}
    >
      <div className="flex items-center gap-2.5 text-sm font-medium">
        <Visible
          if={available}
          else={
            <>
              <LockOutlinedIcon />
              <p>{title}</p>
            </>
          }
        >
          <PlayCircleIcon />
          <p>{title}</p>
        </Visible>
      </div>
      <div className="flex items-center justify-between gap-3">
        <Visible if={available} else={<p className="text-sm">{formatDuration(duration)}</p>}>
          <p className="text-sm text-gray-500">{formatDuration(duration)}</p>
          <div className="flex items-center gap-2">
            <div className="flex-1 rounded-full border border-gray-200 p-0.5">
              <div className="h-2 w-20 rounded-full bg-gray-100">
                <div
                  className="h-2 rounded-full bg-green-500"
                  style={{
                    width: `${progress}%`
                  }}
                />
              </div>
            </div>
            <div className="text-sm font-medium">{progress}%</div>
          </div>
        </Visible>
      </div>
    </div>
  );
};
